import { ScrollTile } from "@/components/scroll-tile";
import { POPULAR_PROJECT_CATEGORY_ID } from "@/lib/constants";
import type { ProjectDto } from "@/openapi/types";

interface ProjectTileProps {
  project: ProjectDto;
  className?: string;
}

export function ProjectTile({ project, className }: ProjectTileProps) {
  const fields = (project.fieldsOfWork ?? []).filter(
    (f) => f.id !== POPULAR_PROJECT_CATEGORY_ID
  );
  // Stable per-project random pick so it doesn't change on re-render
  const primaryField = fields.length > 0
    ? fields[(project.id?.charCodeAt(0) ?? 0) % fields.length]
    : undefined;

  return (
    <ScrollTile
      href={`/projects/${project.slug}`}
      name={project.name}
      logoUrl={project.logoUrl}
      className={className}
      subtitle={
        primaryField?.title ? (
          <div className="flex justify-center w-full">
            <span className="inline-flex items-center rounded-full border border-border/50 px-2 py-0.5 text-[10px] text-muted-foreground whitespace-nowrap truncate max-w-full">
              {primaryField.title}
            </span>
          </div>
        ) : (
          <div />
        )
      }
    />
  );
}
